import { render, staticRenderFns } from "./EntregaCancelar.vue?vue&type=template&id=b05f189a"
import script from "./EntregaCancelar.vue?vue&type=script&lang=js"
export * from "./EntregaCancelar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports